module.exports = __webpack_public_path__ + "img/icon_indicator.be8dc3cb.svg";